<div class="globalLoader" *ngIf="globalLoaderTrigger.IsLoader">
  <!-- <ion-spinner color="primary" name="circles"></ion-spinner> -->
  <div class="loader"></div>
  <div class="loaderText" *ngIf="globalLoaderTrigger.Message">
    {{ globalLoaderTrigger.Message }}
  </div>
</div>
